// client/src/components/Finances/PropertyValueInsights.js

export default function PropertyValueInsights({ valuation }) {
  if (!valuation) {
    return (
      <div className="bg-white shadow rounded-xl p-6 text-sm text-gray-500">
        No valuation data available.
      </div>
    );
  }

  const safe = (n) => Number(n || 0).toLocaleString();

  const {
    estimate,
    comps = [],
    trend = "Flat",
    confidence = "Medium"
  } = valuation;

  return (
    <div className="bg-white shadow rounded-xl p-6">
      {/* TITLE */}
      <h2 className="text-lg font-semibold mb-4">Property Value Insights</h2>

      {/* ------------------------------
          CURRENT ESTIMATE + CONFIDENCE
      ------------------------------- */}
      <div className="flex items-start justify-between mb-6">
        <div>
          <p className="text-gray-500 text-sm">Current Estimate</p>
          <p className="text-2xl font-bold text-gray-900">
            ${safe(estimate)}
          </p>
        </div>

        <div className="text-right">
          <p className="text-xs text-gray-500">Confidence</p>
          <span className="inline-block mt-1 px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
            {confidence}
          </span>
        </div>
      </div>

      {/* ------------------------------
          COMPARABLE SALES (TOP 3)
      ------------------------------- */}
      {comps.length > 0 ? (
        <div className="mb-6">
          <p className="font-medium mb-2 text-sm">Comparable Sales</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {comps.slice(0, 3).map((comp, idx) => (
              <div
                key={idx}
                className="border rounded-md p-3 text-xs bg-gray-50 hover:bg-gray-100 transition"
              >
                <p className="font-semibold text-gray-900 text-sm">
                  {comp.address}
                </p>

                <p className="text-gray-600 mt-1">
                  ${safe(comp.price)}
                </p>

                <p className="text-gray-400 mt-1">
                  {comp.date}
                </p>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <p className="text-xs text-gray-400 mb-4">
          No comparable sales available.
        </p>
      )}

      {/* ------------------------------
          MARKET TREND
      ------------------------------- */}
      <div className="mt-4">
        <p className="text-sm text-gray-500">Market Trend</p>
        <p className="font-semibold text-gray-800">{trend}</p>
      </div>
    </div>
  );
}
